import { ArbeitszeitkontoFixgehalt } from '@/domain/mitarbeiter/features/anlageassistent/content/Zusammenfassung/Bezahlung/ArbeitszeitkontoFixgehalt';
import { ArbeitszeitkontoStundenlohn } from '@/domain/mitarbeiter/features/anlageassistent/content/Zusammenfassung/Bezahlung/ArbeitszeitkontoStundenlohn';
import { Bezahlungsart } from '@/domain/mitarbeiter/features/anlageassistent/content/Zusammenfassung/Bezahlung/Bezahlungsart';
import { Zuschlaege } from '@/domain/mitarbeiter/features/anlageassistent/content/Zusammenfassung/Bezahlung/Zuschlaege';
import { useAnlageassistentFormContext } from '@/domain/mitarbeiter/features/anlageassistent/context/AnlageassistentFormContext';
import { useAnlageassistentContext } from '@/domain/mitarbeiter/features/anlageassistent/context/useAnlageassistentContext';
import {
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
  Button,
  Heading,
  Separator,
  Title,
} from '@e2n/ui/v2';
import { faPen } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';

export function Bezahlung() {
  const { t } = useTranslation();
  const { ctx } = useAnlageassistentContext();
  const form = useAnlageassistentFormContext();
  const data = form.state.values;

  return (
    <AccordionItem value="bezahlung" className="border-none">
      <AccordionTrigger>
        <Heading className="ml-2">
          {t('domain.mitarbeiter.create.steps.bezahlung.title')}
        </Heading>
      </AccordionTrigger>
      <AccordionContent>
        <div className="py-4 flex flex-col gap-2">
          <div className="flex items-center">
            <Title>
              {t(
                'domain.mitarbeiter.create.steps.bezahlung.bezahlungsart.title',
              )}
            </Title>
            <Button
              className="ml-auto"
              iconOnly
              variant={'secondary-red'}
              onClick={() => ctx.navigateToSubStep('bezahlung.bezahlungsart')}>
              <FontAwesomeIcon icon={faPen} />
            </Button>
          </div>
          <Bezahlungsart />
        </div>
        <Separator />
        <div className="py-4 flex flex-col gap-2">
          <div className="flex items-center">
            <Title>
              {t('domain.mitarbeiter.create.steps.bezahlung.sollstunden.title')}
            </Title>
            <Button
              iconOnly
              className="ml-auto"
              variant={'secondary-red'}
              onClick={() =>
                ctx.navigateToSubStep('bezahlung.arbeitszeitkonto')
              }>
              <FontAwesomeIcon icon={faPen} />
            </Button>
          </div>
          {data.bezahlung.bezahlungsart.art === 'fixgehalt' && (
            <ArbeitszeitkontoFixgehalt />
          )}
          {data.bezahlung.bezahlungsart.art === 'stunden' && (
            <ArbeitszeitkontoStundenlohn />
          )}
        </div>
        <Separator />
        <div className="py-4 flex flex-col gap-2">
          <div className="flex items-center">
            <Title>
              {t('domain.mitarbeiter.create.steps.bezahlung.zuschlaege.label')}
            </Title>
            <Button
              iconOnly
              className="ml-auto"
              variant={'secondary-red'}
              onClick={() => ctx.navigateToSubStep('bezahlung.zuschlaege')}>
              <FontAwesomeIcon icon={faPen} />
            </Button>
          </div>
          <Zuschlaege />
        </div>
      </AccordionContent>
    </AccordionItem>
  );
}
